import React from "react";
import { ConfirmDialog } from "@activecollab/components";
import * as PropTypes from "prop-types";

const BlockingPurchaseDialog = ({ open, onClose }) => {
  return (
    <ConfirmDialog
      open={open}
      onConfirm={onClose}
      shouldShowCancelButton={false}
      dialogContent="We are unable to process your request before you settle your
        ActiveCollab subscription payment."
      confirmBtnText="I understand"
      dialogTitle="Action Not Permitted"
    />
  );
};

BlockingPurchaseDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default BlockingPurchaseDialog;
